import React, { useEffect, useState, KeyboardEvent, SyntheticEvent } from 'react';
import {
  Table,
  Icon,
  Dimmer,
  Segment,
  Loader,
  Dropdown,
  Form,
  Grid,
  Modal,
  Input,
  Popup
} from 'semantic-ui-react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { iRootState, iRootDispatch } from '../../store';
import CustomDatePicker from '../../components/CustomDatePicker';
import {
  ContextEnum,
  EntityEnum,
  LabelEnum,
  OriginEnum,
  ProviderEnum,
  StatusEnum,
  TypeEnum
} from './enums';
import { DataSyncFilter, EventsFilter, EventsResponseType } from './types';
import moment from 'moment';
import { getEvents, getMailEvents } from '../../services/events';
import { isEmptyObject } from '../../util';
import { dangerNotification } from '../../services/notification';
import Lottie from 'react-lottie';
import Coding from '../../resources/lotties/coding3.json';
import { DATE_INPUT_MASK, maskPhoneNumber } from '../../services/masks';
import { FieldLabel } from '../../styles';
import { getDataSyncControlEntries } from '../../services/external-sync-control';
import TablePaginationMenu from '../../components/TablePaginationMenu';
import { StepCardProps } from '../estates-edit-form/styles';
import { SpecificInfosWrapper } from '../reports-form/styles';
import AppMaskedInput from '../../components/MaskedInput';
import Button from '../../components/Button';

const Header = styled(Table.Header)`
  background-color: #e1e8ed;
`;

const TableWrapper = styled.div`
  font-size: 0.85em;
  font-weight: bold;

  .ui.table {
    border: none;
    text-align: center;
    color: #364445;
  }
`;

const NotFoundWrapper = styled.div`
  width: 100%;
  text-align: center;
  color: #364445;
  font-size: 1.2em;
`;

export const StepCard = styled.div<StepCardProps>`
  cursor: pointer;
  padding: 8px 20px;
  border-radius: 5px;
  width: fit-content;
  margin-bottom: 10px;
  background-color: ${props =>
    props.active ? props.theme.secundary.color : 'transparent'};
  color: ${props => (props.active ? 'white' : 'black')};
  span {
    font-weight: bold;
    font-size: 14px;
  }
`;

export const SmallData = styled.div`
  width: 350px;
  display: flex;
  padding-right: 20px;
`;

const mapState = (state: iRootState) => ({
  estatesList: state.estatesList,
  user: state.user,
  availableBrokersAndEstates: state.availableBrokersAndEstates
});

const mapDispatch = (dispatch: iRootDispatch) => ({
  updateEstatesList: (payload: any) => dispatch.estatesList.updateEstatesList(payload)
});

const defaultOptions = {
  loop: true,
  autoplay: true,
  animationData: Coding,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice'
  }
};

export type EventsTableProps = ReturnType<typeof mapState>;

const EventsTable = (props: EventsTableProps) => {
  const { availableBrokersAndEstates } = props;
  const [dataCount, setDataCount] = useState<number>(0);
  const [events, setEvents] = useState<EventsResponseType[]>([]);
  const [dataSyncEntries, setDataSyncEntries] = useState<any>([]);
  const [dataSyncCount, setDataSyncCount] = useState<number>(0);
  const [page, setPage] = useState<number>(1);
  const [oldPage, setOldPage] = useState<number>(1);
  const [isLoadingEvents, setIsLoadingEvents] = useState<boolean>(false);

  const [startDate, setStartDate] = useState<Date | null>(null);
  const [endDate, setEndDate] = useState<Date | null>(null);
  const [type, setType] = useState<string>('');
  const [origin, setOrigin] = useState<string>('');
  const [context, setContext] = useState<string>('');
  const [label, setLabel] = useState<string>('');
  const [code, setCode] = useState<string>('');
  const [provider, setProvider] = useState<string>('');
  const [entity, setEntity] = useState<string>('');
  const [relatedId, setRelatedId] = useState<string>('');
  const [status, setStatus] = useState<number>();

  const [currentPayload, setCurrentPayload] = useState<any>({});
  const [currentCode, setCurrentCode] = useState<number>(0);
  const [isPayloadModalOpen, setIsPayloadModalOpen] = useState<boolean>(false);
  const [logType, setLogType] = useState<string>('events');
  const mailOptions = [
    {
      key: 'NEW_INVOICE',
      text: 'Notificação de Faturas',
      value: 'NEW_INVOICE'
    }
  ];

  const handleSubmit = async () => {
    setPage(1);
    getData();
  };

  const isPayloadEmpty = (payload: { new: any; old?: any }) => {
    if (payload.new || payload.old) {
      if (payload.new) {
        return false;
      }

      return true;
    } else {
      return true;
    }
  };

  useEffect(() => {
    console.log(context);
  }, [context]);

  useEffect(() => {
    if (startDate && logType === 'integrations') {
      const addThirtyDays = (date: Date) => {
        const newDate = new Date(date);
        newDate.setDate(newDate.getDate() + 30);
        return newDate;
      };

      setEndDate(addThirtyDays(startDate));
    }
  }, [startDate]);

  const clearFilters = (): void => {
    setStartDate(null);
    setEndDate(null);
    setType('');
    setOrigin('');
    setContext('');
    setLabel('');
    setCode('');
    setRelatedId('');
    setProvider('');
    setEntity('');
  };

  const getData = async () => {
    if (!startDate && !endDate) {
      dangerNotification(
        'Não foi possível realizar busca',
        'Por favor, selecione a Data Inical e Data Final'
      );
      return;
    }

    setIsLoadingEvents(true);
    try {
      const filters: EventsFilter = {
        page: page,
        start: startDate ? moment(startDate).format('YYYY-MM-DD') : null,
        end: endDate ? moment(endDate).format('YYYY-MM-DD') : null,
        type: type ? type : null,
        origin: origin ? origin : null,
        context: context ? context : null,
        label: label ? label : null,
        code: code ? Number(code) : null,
        relatedId: relatedId ? relatedId : null
      };
      const dataSyncFilters: DataSyncFilter = {
        page: page,
        start: startDate ? moment(startDate).format('YYYY-MM-DD') : null,
        end: endDate ? moment(endDate).format('YYYY-MM-DD') : null,
        provider: provider ? provider : null,
        entity: entity ? entity : null,
        relatedId: relatedId ? relatedId : null,
        status: status ? status : null
      };

      if (logType === 'events') {
        const response: { data: any; count: number } = await getDataSyncControlEntries(
          dataSyncFilters
        );
        setDataSyncEntries(response.data);
        setDataSyncCount(response.count);
      } else if (logType === 'integrations') {
        const response: { data: EventsResponseType[]; count: number } = await getEvents(
          filters
        );
        setEvents(response.data);
        setDataCount(response.count);
      } else {
        const response: { data: EventsResponseType[]; count: number } =
          await getMailEvents(filters);
        setEvents(response.data);
        setDataCount(response.count);
      }
    } catch (err) {
      dangerNotification(
        'Erro',
        'Não foi possível realizar a consulta. Contate o administrador.'
      );
    } finally {
      setIsLoadingEvents(false);
    }
  };

  useEffect(() => {
    if (page !== oldPage) {
      setOldPage(page);
      getData();
    }
  }, [page, oldPage]);

  const openPayloadModal = (payload: any, code: number) => {
    setCurrentPayload(payload);
    setCurrentCode(code);
    setIsPayloadModalOpen(true);
  };

  const handleEnterKeyPress = (e: KeyboardEvent) => {
    if (e.key === 'Enter') {
      e.preventDefault();
    }
  };

  function renderEventLogTableHeader() {
    return (
      <Table.Row>
        <Table.HeaderCell>#</Table.HeaderCell>
        <Table.HeaderCell>Data</Table.HeaderCell>
        <Table.HeaderCell>Origem</Table.HeaderCell>
        <Table.HeaderCell>Label</Table.HeaderCell>
        <Table.HeaderCell>Related ID</Table.HeaderCell>
        <Table.HeaderCell>Mensagem</Table.HeaderCell>
        <Table.HeaderCell>Usuário</Table.HeaderCell>
        <Table.HeaderCell>Payload</Table.HeaderCell>
      </Table.Row>
    );
  }

  function renderTableData() {
    return events.map((event: any) => {
      return (
        <Table.Row key={event.code}>
          <Table.Cell>{event.code}</Table.Cell>
          <Table.Cell>
            {moment(event.createdAt).format('DD/MM/YYYY - HH:mm:ss')}
          </Table.Cell>
          <Table.Cell>{event.origin}</Table.Cell>
          <Table.Cell>{event.label}</Table.Cell>
          <Table.Cell>{event.relatedId}</Table.Cell>
          <Table.Cell>{event.content}</Table.Cell>
          <Table.Cell style={{ cursor: event.user?.name ? 'help' : 'default' }}>
            {event.user?.name ? (
              <Popup
                trigger={<span>{event.user.name}</span>}
                flowing={true}
                position={'left center'}
              >
                <Popup.Content>
                  <div>
                    <strong>Nome: </strong> {event.user.name}
                  </div>
                  <div>
                    <strong>E-mail: </strong> {event.user.email}
                  </div>
                  <div>
                    <strong>Telefone: </strong>
                    {event.user.cellphone ? maskPhoneNumber(event.user.cellphone) : ''}
                  </div>
                  <div>
                    <strong>Perfil: </strong> <i>{event.user.role}</i>
                  </div>
                  {event.user.broker && (
                    <div>
                      <strong>Corretora: </strong> {event.user.broker.name}
                    </div>
                  )}
                  {event.user.estate && (
                    <div>
                      <strong>Imobiliária: </strong> {event.user.estate.name}
                    </div>
                  )}
                </Popup.Content>
              </Popup>
            ) : (
              '-'
            )}
          </Table.Cell>
          <Table.Cell>
            {!isPayloadEmpty(event.payload) ? (
              <Icon
                name={'eye'}
                onClick={() => openPayloadModal(event.payload, event.code)}
                style={{ cursor: 'pointer' }}
              />
            ) : (
              <Icon name={'ban'} style={{ cursor: 'no-drop' }} />
            )}
          </Table.Cell>
        </Table.Row>
      );
    });
  }

  function renderTableIntegrationData() {
    return dataSyncEntries.map((dataSyncEntry: any) => {
      const createdAt = new Date(dataSyncEntry.created_at);
      const dateFormatted = createdAt.toLocaleDateString('pt-BR');
      const timeFormatted = createdAt.toLocaleTimeString('pt-BR');
      const policyIssueDate = moment(
        dataSyncEntry.hiredData.insurerPolicyCreatedAt
      ).format('DD/MM/YYYY - HH:mm:ss');

      return (
        <Table.Row key={dataSyncEntry.id}>
          <Table.Cell>{`${dateFormatted} ${timeFormatted}`}</Table.Cell>
          <Table.Cell>
            {dataSyncEntry.status == 1 ? 'Não Sincronizado' : 'Sincronizado'}
          </Table.Cell>
          <Table.Cell>{`${policyIssueDate}`}</Table.Cell>
          <Table.Cell>{dataSyncEntry.hiredData.insurerPolicyId}</Table.Cell>
          <Table.Cell>{dataSyncEntry.entity}</Table.Cell>
          <Table.Cell>{dataSyncEntry.provider_id}</Table.Cell>
          <Table.Cell>
            {dataSyncEntry.hiredData.bondInsurance.naturalTenant
              ? dataSyncEntry.hiredData.bondInsurance.naturalTenant.main_tenant_name
              : dataSyncEntry.hiredData.bondInsurance.legalTenant.company}
          </Table.Cell>
          <Table.Cell>{dataSyncEntry.hiredData.bondInsurance.estate.name}</Table.Cell>
          <Table.Cell>{dataSyncEntry.observations}</Table.Cell>
        </Table.Row>
      );
    });
  }

  function renderIntegrationLogTableHeader() {
    return (
      <Table.Row>
        <Table.HeaderCell>Data de Criação</Table.HeaderCell>
        <Table.HeaderCell>Status</Table.HeaderCell>
        <Table.HeaderCell>Data de Emissão da Apólice</Table.HeaderCell>
        <Table.HeaderCell>Apólice</Table.HeaderCell>
        <Table.HeaderCell>Entidade</Table.HeaderCell>
        <Table.HeaderCell>Provedor</Table.HeaderCell>
        <Table.HeaderCell>Locatário</Table.HeaderCell>
        <Table.HeaderCell>Imobiliária</Table.HeaderCell>
        <Table.HeaderCell>Observações</Table.HeaderCell>
      </Table.Row>
    );
  }

  useEffect(() => {
    if (!isEmptyObject(currentPayload)) {
      console.log({ currentPayload });
    }
  }, [currentPayload]);

  function renderPayloadView() {
    const payload: { new: any; old: any } = currentPayload;

    if (typeof payload?.new === typeof payload?.old) {
      return (
        <div>
          <h3>New</h3>
          <pre>{JSON.stringify(payload.new, null, 2)}</pre>
          <h3>Old</h3>
          <pre>{JSON.stringify(payload.old, null, 2)}</pre>
        </div>
      );
    }

    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        <h1>Em desenvolvimento...</h1>
        <Lottie options={defaultOptions} height={500} width={500} />
      </div>
    );
  }

  return (
    <>
      <Form>
        <Grid.Row>
          <Grid.Column width={4}>
            <StepCard
              active={logType === 'events'}
              onClick={() => {
                setLogType('events');
              }}
            >
              <span>Eventos</span>
            </StepCard>
          </Grid.Column>
          <Grid.Column width={5}>
            <StepCard
              active={logType === 'integrations'}
              onClick={() => {
                setLogType('integrations');
              }}
            >
              <span>Integrações</span>
            </StepCard>
          </Grid.Column>
          <Grid.Column width={4}>
            <StepCard
              active={logType === 'mails'}
              onClick={() => {
                setContext('MAIL_SENDER');
                setLogType('mails');
              }}
            >
              <span>Emails de Notificação</span>
            </StepCard>
          </Grid.Column>
        </Grid.Row>
        <Grid columns={'equal'}>
          {logType === 'mails' && (
            <>
              <Grid.Column width={3}>
                <FieldLabel>Imobiliária</FieldLabel>
                <div>
                  <Dropdown
                    style={{ width: '100%' }}
                    name={`estate`}
                    options={availableBrokersAndEstates.estates || []}
                    placeholder={'Selecionar...'}
                    search
                    selection
                    onChange={(e, { value }) => {
                      setRelatedId((value as any).id as string);
                    }}
                    clearable
                  />
                </div>
              </Grid.Column>

              <Grid.Column width={3}>
                <FieldLabel>Tipo Email</FieldLabel>
                <div>
                  <Dropdown
                    style={{ width: '100%' }}
                    value={label}
                    name={`estate`}
                    options={mailOptions}
                    placeholder={'Selecionar...'}
                    search
                    selection
                    onChange={(e, { value }) => setLabel(value as string)}
                    clearable
                  />
                </div>
              </Grid.Column>

              <Grid.Column width={5}>
                <FieldLabel style={{ paddingRight: '16px' }}>Período</FieldLabel>
                <SpecificInfosWrapper>
                  <SmallData>
                    <FieldLabel
                      style={{
                        paddingRight: '16px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontWeight: 'normal'
                      }}
                    >
                      De
                    </FieldLabel>
                    <div
                      style={{
                        width: '110px'
                      }}
                    >
                      <CustomDatePicker
                        maxDate={new Date()}
                        name="start"
                        selected={startDate}
                        onChange={(date: Date, e: SyntheticEvent) => {
                          setStartDate(date);
                        }}
                        component={CustomDatePicker}
                        customInput={<AppMaskedInput mask={DATE_INPUT_MASK} />}
                        dateFormat={'dd/MM/yyyy'}
                      />
                    </div>
                  </SmallData>

                  <SmallData>
                    <FieldLabel
                      style={{
                        paddingRight: '16px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontWeight: 'normal'
                      }}
                    >
                      Até
                    </FieldLabel>
                    <div
                      style={{
                        width: '110px'
                      }}
                    >
                      <CustomDatePicker
                        maxDate={new Date()}
                        name="end"
                        selected={endDate}
                        onChange={(date: Date, e: SyntheticEvent) => {
                          setEndDate(date);
                        }}
                        component={CustomDatePicker}
                        customInput={<AppMaskedInput mask={DATE_INPUT_MASK} />}
                        dateFormat={'dd/MM/yyyy'}
                      />
                    </div>
                  </SmallData>
                </SpecificInfosWrapper>
              </Grid.Column>

              <Grid.Column width={'5'} floated={'right'}>
                <Grid columns={'equal'}>
                  <Grid.Column>
                    <Form.Field>
                      <label>&nbsp;</label>
                      <Button
                        light
                        fluid
                        onClick={clearFilters}
                        labelPosition="right"
                        icon={'eraser'}
                        content={'Limpar Filtros'}
                      />
                    </Form.Field>
                  </Grid.Column>
                  <Grid.Column>
                    <Form.Field>
                      <label>&nbsp;</label>
                      <Button
                        fluid
                        onClick={handleSubmit}
                        labelPosition="right"
                        icon={'search'}
                        content={'Pesquisar'}
                      />
                    </Form.Field>
                  </Grid.Column>
                </Grid>
              </Grid.Column>
            </>
          )}

          {logType !== 'mails' && (
            <Grid.Row>
              <Grid.Column width={2}>
                <Form.Field>
                  <label>Data inicial</label>
                  <CustomDatePicker
                    fluid
                    maxDate={endDate && endDate}
                    value={startDate && moment(startDate).format('DD/MM/YYYY')}
                    onChange={(date: Date) => setStartDate(date)}
                    placeholder={'Data Inicial'}
                  />
                </Form.Field>
              </Grid.Column>

              <Grid.Column width={2}>
                <Form.Field>
                  <label>Data final</label>
                  <CustomDatePicker
                    fluid
                    placeholder={'Data Final'}
                    minDate={startDate && startDate}
                    value={endDate && moment(endDate).format('DD/MM/YYYY')}
                    onChange={(date: Date) => setEndDate(date)}
                  />
                </Form.Field>
              </Grid.Column>

              {logType !== 'mails' && (
                <Grid.Column width={logType === 'integrations' ? 2 : 3}>
                  <Form.Field>
                    <label>{logType === 'integrations' ? 'TYPE' : 'PROVEDOR'}</label>
                    <Dropdown
                      fluid
                      onChange={
                        logType === 'integrations'
                          ? (e, { value }) => setType(String(value))
                          : (e, { value }) => setProvider(String(value))
                      }
                      value={logType === 'integrations' ? type : provider}
                      placeholder={logType === 'integrations' ? 'Type' : 'Provedor'}
                      options={logType === 'integrations' ? TypeEnum : ProviderEnum}
                      selection
                      clearable
                      search
                    />
                  </Form.Field>
                </Grid.Column>
              )}

              {logType !== 'mails' && (
                <Grid.Column width={logType === 'integrations' ? 2 : 4}>
                  <Form.Field>
                    <label>{logType === 'integrations' ? 'ORIGIN' : 'Entidade'}</label>
                    <Dropdown
                      fluid
                      onChange={
                        logType === 'integrations'
                          ? (e, { value }) => setOrigin(String(value))
                          : (e, { value }) => setEntity(String(value))
                      }
                      value={logType === 'integrations' ? origin : entity}
                      placeholder={logType === 'integrations' ? 'Origin' : 'Entidade'}
                      options={logType === 'integrations' ? OriginEnum : EntityEnum}
                      selection
                      clearable
                      search
                    />
                  </Form.Field>
                </Grid.Column>
              )}
              {logType === 'events' && (
                <Grid.Column>
                  <Form.Field>
                    <label>STATUS</label>
                    <Dropdown
                      fluid
                      onChange={(e, { value }) => setStatus(Number(value))}
                      value={status}
                      placeholder={'Status'}
                      options={StatusEnum}
                      selection
                      clearable
                      search
                    />
                  </Form.Field>
                </Grid.Column>
              )}

              {logType === 'integrations' && (
                <Grid.Column>
                  <Form.Field>
                    <label>LABEL</label>
                    <Dropdown
                      fluid
                      onChange={(e, { value }) => setLabel(String(value))}
                      value={label}
                      placeholder={'Label'}
                      options={LabelEnum}
                      selection
                      clearable
                      search
                    />
                  </Form.Field>
                </Grid.Column>
              )}

              {logType !== 'mails' && (
                <Grid.Column>
                  <Form.Field>
                    <label>CONTEXT</label>
                    <Dropdown
                      fluid
                      onChange={(e, { value }) => setContext(String(value))}
                      value={context}
                      placeholder={'Context'}
                      options={ContextEnum}
                      selection
                      clearable
                      search
                    />
                  </Form.Field>
                </Grid.Column>
              )}
            </Grid.Row>
          )}

          {logType !== 'mails' && (
            <Grid.Row>
              <Grid.Column width={2}>
                <Form.Field>
                  <label>CODE</label>
                  <Input
                    fluid
                    onChange={event => {
                      if (!isNaN(Number(event.target.value)))
                        setCode(String(event.target.value));
                    }}
                    onKeyUp={handleEnterKeyPress}
                    value={code}
                    placeholder={'Code'}
                  />
                </Form.Field>
              </Grid.Column>

              {logType === 'integrations' && (
                <Grid.Column width={4}>
                  <Form.Field>
                    <label>RELATED ID</label>
                    <Input
                      fluid
                      onChange={event => setRelatedId(String(event.target.value))}
                      onKeyUp={handleEnterKeyPress}
                      value={relatedId}
                      placeholder={'Related ID'}
                    />
                  </Form.Field>
                </Grid.Column>
              )}
              <Grid.Column width={'5'} floated={'right'}>
                <Grid columns={'equal'}>
                  <Grid.Column>
                    <Form.Field>
                      <label>&nbsp;</label>
                      <Button
                        light
                        fluid
                        onClick={clearFilters}
                        labelPosition="right"
                        icon={'eraser'}
                        content={'Limpar Filtros'}
                      />
                    </Form.Field>
                  </Grid.Column>
                  <Grid.Column>
                    <Form.Field>
                      <label>&nbsp;</label>
                      <Button
                        fluid
                        onClick={handleSubmit}
                        labelPosition="right"
                        icon={'search'}
                        content={'Pesquisar'}
                      />
                    </Form.Field>
                  </Grid.Column>
                </Grid>
              </Grid.Column>
            </Grid.Row>
          )}
        </Grid>
      </Form>

      <Dimmer.Dimmable as={Segment} dimmed={isLoadingEvents}>
        <Dimmer active={isLoadingEvents} inverted>
          <Loader />
        </Dimmer>
        {(events && events.length > 0) ||
        (dataSyncEntries && dataSyncEntries.length > 0) ? (
          <TableWrapper>
            <Table>
              <Header>
                {logType === 'integrations'
                  ? renderEventLogTableHeader()
                  : renderIntegrationLogTableHeader()}
              </Header>
              <Table.Body>
                {logType === 'integrations'
                  ? renderTableData()
                  : renderTableIntegrationData()}
              </Table.Body>
              <Table.Footer>
                <Table.Row>
                  <Table.HeaderCell colSpan="17">
                    <TablePaginationMenu
                      currentPage={page}
                      dataCount={logType === 'integrations' ? dataCount : dataSyncCount}
                      setCurrentPage={setPage}
                    />
                  </Table.HeaderCell>
                </Table.Row>
              </Table.Footer>
            </Table>
          </TableWrapper>
        ) : (
          <NotFoundWrapper>
            <p>Nenhum Log Cadastrado</p>
          </NotFoundWrapper>
        )}
      </Dimmer.Dimmable>

      <Modal
        open={isPayloadModalOpen}
        onClose={() => setIsPayloadModalOpen(false)}
        size={'large'}
      >
        <Modal.Header>Detalhes do Payload #{currentCode}</Modal.Header>
        <Modal.Content scrolling>{renderPayloadView()}</Modal.Content>
      </Modal>
    </>
  );
};

export default connect(mapState, mapDispatch)(EventsTable);
